import { render, staticRenderFns } from "./Sysrole.vue?vue&type=template&id=f3d2c372&"
import script from "./Sysrole.vue?vue&type=script&lang=js&"
export * from "./Sysrole.vue?vue&type=script&lang=js&"
import style0 from "./Sysrole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports